import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  MainHeaderButtonsWrapper: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '8px',
    alignItems: 'center',
    width: '100%',
    // marginLeft: "auto",
    // "& > *": {
    // 	margin: theme.spacing(1),
    // },
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'flex-start'
    }
  }
}))
